<template>
  <main class="directory">
    <transition name="context">
      <context-slot v-show="!contextSlotHidden">
        <button
          v-for="section in fontSections" 
          :key="section.id"
          class="section-link" 
          :class="{ 'active': active === section.id }" 
          @click="_scrollToSection(section.id)">
          {{ section.type }}
        </button>
      </context-slot>
    </transition>
    <directory-section v-for="section in fontSections" 
      :key="section.id"
      :ref="section.id"
      :id="section.id"
      :type="section.type"
      :fonts="section.fonts"
    />
  </main>
</template>

<script>
  import { mapActions, mapState } from 'vuex';
  import VueScrollTo from 'vue-scrollto';
  import fonts from '@/assets/data/fonts.json';
  import ContextSlot from '@/components/ContextSlot';
  import DirectorySection from './components/DirectorySection';

  export default {
    name: 'directory',
    components: {
      'directory-section': DirectorySection,
      'context-slot': ContextSlot,
    },
    computed: {
      ...mapState('ui', [
        'contextSlotHidden',
        'isMobile'
      ])
    },
    data() {
      return {
        active: null
      }
    },
    created() {
      this.fontSections = [
        {
          type: 'Sans Serif',
          id: 'sansSerif',
          fonts: fonts.filter(font => font.type === 'sans-serif')
        },
        {
          type: 'Serif',
          id: 'serif',
          fonts: fonts.filter(font => font.type === 'serif')
        },
        {
          type: 'Other',
          id: 'other',
          fonts: fonts.filter(font => font.type === 'other')
        }
      ];
    },
    mounted() {
      this.observer = new IntersectionObserver(([entry]) => {
        if (entry && entry.isIntersecting) {
          this.active = entry.target.id;
        }
      }, { rootMargin: '-50%' });
      this.fontSections.forEach(section => {
        this.observer.observe(this.$refs[section.id][0].$el);
      })
    },
    methods: {
      ...mapActions('ui', [
        'setContextSlotState'
      ]),
      _scrollToSection(section) {
        VueScrollTo.scrollTo(this.$refs[section][0].$el, 1000, {offset: -112});
        if (this.isMobile) {
          this.setContextSlotState(!this.contextSlotHidden);
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .directory {
    position: relative;
    top: 3.5rem;
    padding: 6rem 0;
  }
  .section-link {
    display: block;
    font-size: 0.875rem;
    margin-bottom: 0.5rem;
    color: #8c8c8c;

    &.active {
      color: #000;
    }
  }
  .context-enter-active, .context-leave-active {
    transition: all 500ms ease-in-out;
  }
  
  .context-enter, .context-leave-to {
    transform: translateY(-16rem);
  }
</style>
